@if (on === 'form' && control.field.condensed) {
  <!-- Read-only condensed row - matches the picklist / date condensed format so a checkbox
       lines up in a column of condensed fields. Never editable in this form. -->
  <div style="display:flex; width:calc(100% - 10px); height:25px; overflow:hidden; margin:0 10px;
              align-items:bottom; white-space:nowrap; box-sizing:border-box">
    <!-- .cbx-condensed-label mirrors .condensed-label (styles/_condensed-field.scss); it is
         styled in this component's scss rather than shared because this component is
         ViewEncapsulation.None, where :host-context is not shimmed. -->
    <div class="cbx-condensed-label" style="flex:1; overflow:hidden">{{control.field.label}}</div>
    <div style="align-content:center; display:flex">
      <mat-icon [attr.data-field]="control.field.name" [style.opacity]="opacity"
        [color]="control.value ? color : ''"
        style="font-size:20px; height:20px; width:20px">{{ control.value ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
      <div style="width:34px; display:flex; justify-content:flex-end; align-items:center">
        @if (control.field.hint) {
          <mat-icon style="font-size:18px; height:18px; width:18px"
            [matTooltip]="control.field.hint" matTooltipPosition="above">help</mat-icon>
        }
      </div>
    </div>
  </div>
}
@if (on === 'form' && !control.field.condensed) {
  <div style="height:62px; padding-top: 12px; padding-left: 10px">
    <div style="float:left">
      @if (!this.control.value) {
        <mat-icon [attr.data-field]="control.field.name" [style.opacity]="opacity" [color]="control.disabled ? '' : color" (click)="turnOn()">check_box_outline_blank</mat-icon>
      }
      @if (this.control.value) {
        <mat-icon [attr.data-field]="control.field.name" [style.opacity]="opacity" [color]="control.disabled ? '' : color" (click)="turnOff()">check_box_outline</mat-icon>
      }
    </div>
    <div style="float:left; margin-left:5px" [matTooltip]="control.getErrorMessage()">
      <span [ngClass]="control.invalid && control.touched ? 'error' : null">{{control.field.label}}</span>
    </div>
    <div style="float:right; padding-right: 12px">
      @if (control.field.hint) {
        <mat-icon color="primary" [matTooltip]="control.field.hint">info</mat-icon>
      }
    </div>
  </div>
}
@if (on !== 'form') {
  <div >
    @if (!this.control.value) {
      <mat-icon [attr.data-field]="control.field.name" [style.opacity]="opacity" [color]="control.disabled ? '' : color" (click)="turnOn()">check_box_outline_blank</mat-icon>
    }
    @if (this.control.value) {
      <mat-icon [attr.data-field]="control.field.name" [style.opacity]="opacity" [color]="control.disabled ? '' : color" (click)="turnOff()">check_box_outline</mat-icon>
    }
  </div>
}
<!--
<mat-checkbox *ngIf="on !== 'form'" [formControl]="control"color="primary" (click)="clickIt($event)"></mat-checkbox>
<div *ngIf="on === 'form'" style="height: 38px; padding: 1.5em 1.25em 1em 1.25em">
  <mat-checkbox [formControl]="control" color="primary" (click)="clickIt($event)">{{control.field.label}}</mat-checkbox>
  <p><span style="font-size: smaller; color: rgba(0,0,0,0.6)">{{control.field.hint}}</span></p>
</div>
-->
